<div class="page-wrapper">
  <div class="header">
    <div class="header-content">
      <img
        class="logo"
        [src]="header?.logo?.data?.attributes?.url"
        alt="endsleigh logo"
      />
      <h4 class="subtitle-text">Howden for Students</h4>
    </div>
  </div>

  <section class="content-container">
    <ng-container *ngIf="!isLoading; else loader">
      <div *ngIf="pageData">
        <ng-container *ngIf="!failed; else failure">
          <div class="content-wrapper">
            <h1>{{ pageData.Title }}</h1>
            <div class="separator"></div>
          </div>
          <p>{{ pageData.message }}</p>
        </ng-container>
        <ng-template #failure>
          <div class="content-wrapper">
            <h1>Failed to update your preferences</h1>
            <div class="separator"></div>
          </div>
          <p>
            Something went wrong and we failed to update your preferences.
            Please login using the button below and update your email
            preferences.
          </p>
        </ng-template>
        <a href="/">
          <button>Login</button>
        </a>
      </div>
      <div class="image-wrapper">
        <img
          class="mobile-image"
          [src]="pageData?.image?.data?.attributes?.url"
          alt=""
        />
      </div>
    </ng-container>
    <ng-template #loader>
      <div class="page-wrapper">
        <div class="spinner"></div>
      </div>
    </ng-template>
  </section>
</div>
